import axios from 'axios';
import config from '../config/Constant';
import FileSaver from 'file-saver';
export const API_BASE_URL = config.urls.api_base_url;

// Need to fix this
// In case of network error
function prepareResponse(response) {
  let err = false;
  let error_message = '';
  if (response.data === undefined) {
    error_message = 'Api Failed to fetch the data';
    err = true;
  }

  // Need to check this with ALI
  if (response.data && response.data.error) {
    error_message = response.data.message;
    err = true;
  }

  if (err) {
    return {
      success: false,
      error: true,
      message: error_message,
      status_code: response.data.status_code,
      code: response.data.code,
      data: response.data.data || {},
    };
    // eslint-disable-next-line no-else-return
  } else {
    const responseData = {
      success: true,
      error: false,
      message: response.data.message,
      status_code: response.data.status_code,
      code: response.data.code,
      data: response.data.data,
    };

    if (response.data.pagination_data) {
      responseData.pagination = response.data.pagination_data;
    }
    return responseData;
  }
}

// Prepare catch
function prepareCatchResponse(err) {
  return {
    success: false,
    error: true,
    message: `${err.name} - ${err.message}`,
    status_code: err.status,
    code: err.status,
    data: {},
  };
}

// Post request with out access token
export function postRequestWithoutAccessToken(url, data, next) {
  axios
    .post(API_BASE_URL + url, data)
    .then(response => {
      next(prepareResponse(response));
    })
    .catch(error => {
      next(prepareCatchResponse(error));
    });
}

export function getRequest(url, data, next) {
  axios
    .get(API_BASE_URL + url, data)
    .then(response => {
      next(prepareResponse(response));
    })
    .catch(err => {
      next(prepareCatchResponse(err));
    });
}

export function getStaticRequest(url, data, next) {
  axios
    .get(API_BASE_URL + url, data)
    .then(response => {
      next(response);
    })
    .catch(err => {
      next(prepareCatchResponse(err));
    });
}

// Get without Authentication
export const getRequestWithoutAccessToken = async (url, next) => {
  try {
    const res = await axios.get(API_BASE_URL + url);
    next(prepareResponse(res));
  } catch (err) {
    next(prepareCatchResponse(err));
  }
};

export function postRequest(url, data, access_token, next) {
  const headers = {
    headers: {
      Authorization: access_token,
    },
  };
  axios
    .post(API_BASE_URL + url, data, headers)
    .then(response => {
      next(prepareResponse(response));
    })
    .catch(err => {
      console.log('err ', err);
      next(prepareCatchResponse(err));
    });
}

export function putRequest(url, data, access_token, next) {
  const headers = {
    headers: {
      Authorization: access_token,
    },
  };
  axios
    .put(API_BASE_URL + url, data, headers)
    .then(response => {
      next(prepareResponse(response));
    })
    .catch(err => {
      next(prepareCatchResponse(err));
    });
}

export function deleteRequest(url, data, next) {
  axios
    .delete(API_BASE_URL + url, data)
    .then(response => {
      next(prepareResponse(response));
    })
    .catch(err => {
      next(prepareCatchResponse(err));
    });
}

export function patchRequest(url, data, access_token, next) {
  const headers = {
    headers: {
      Authorization: access_token,
    },
  };
  axios
    .patch(API_BASE_URL + url, data, headers)
    .then(response => {
      next(prepareResponse(response));
    })
    .catch(err => {
      console.log('err ', err);
      next(prepareCatchResponse(err));
    });
}


export function downloadFile(params, next) {
  const { url, data, access_token, fileName } = params;

  const headers = {
    headers: {
      Authorization: access_token.token,
    },
    responseType: 'blob',
  };
  axios
    .post(API_BASE_URL + url, data, headers)
    .then(response => {
      if (response.status == 200) {
        FileSaver.saveAs(response.data, fileName);
      }
      next(prepareResponse(response));
    })
    .catch(err => {
      console.error(err);
    });
}


export function uploadFile(url, file, access_token, next) {
  const headers = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: access_token,
    },
  };

  const formData = new FormData();
  formData.append('file', file);

  axios
    .post(API_BASE_URL + url, formData, headers)
    .then(response => {
      next(prepareResponse(response));
    })
    .catch(err => {
      console.log('err ', err);
      next(prepareCatchResponse(err));
    });
}